import Svg, { Path } from "react-native-svg";
import { GetProps } from "tamagui";

const BloodPressureMonitor = ({ color, ...props }: GetProps<typeof Svg>) => (
  <Svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <Path
      d="M10 11V1M5 21L5 22C5 22.5523 5.44772 23 6 23H11C11.5523 23 12 22.5523 12 22L12 11M5 21C6.933 21 8.5 19.433 8.5 17.5C8.5 15.567 6.933 14 5 14C3.067 14 1.5 15.567 1.5 17.5C1.5 19.433 3.067 21 5 21ZM5 16.5V17.5M21 19L21 22C21 22.5523 20.5523 23 20 23H16.5C15.9477 23 15.5 22.5523 15.5 22V11M21 19C19.8954 19 19 18.1046 19 17V15C19 13.8954 19.8954 13 21 13C22.1046 13 23 13.8954 23 15V17C23 18.1046 22.1046 19 21 19ZM2 1H17C17.5523 1 18 1.44772 18 2V10C18 10.5523 17.5523 11 17 11H2C1.44772 11 1 10.5523 1 10V2C1 1.44772 1.44772 1 2 1Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </Svg>
);

export default BloodPressureMonitor;
